/*
 * 审核人弹出框参数
 * @author miqiang
 * @date 2020-02-25
 */
export class ShrAssemblyParams {
  /**
   * 列表查询的url
   */
  public url: string;

  /**
   * 提交流程时的url
   */
  public submitUrl: string;

  /**
   * 是否单选
   */
  public isSingle: boolean;

  constructor(url: string, submitUrl: string, isSingle: boolean = true) {
    this.url = url;
    this.submitUrl = submitUrl;
    this.isSingle = isSingle;
  }
}
